import { merge } from 'lodash-es';

export const applyPagingParams = {
  common: (requestParams, { marker, limit }) => ({
    limit,
    marker,
    with_count: true,
    ...requestParams,
  }),
  s3: (requestParams, { marker, limit }) => merge({}, requestParams, {
    params: {
      marker,
      count: limit
    }
  })
};

export const getNextMarker = {
  common: (response: FetchResponse): ID => response.data.pages?.find((cursor) => cursor.rel === 'next')?.marker,
  s3: (response: FetchResponse): ID => response.data.next_marker
};

export const isPageLast = {
  common: (response, nextMarker, items, limit): boolean => !nextMarker || items.length < limit,
  s3: (response: FetchResponse, nextMarker): boolean => !response.data.is_truncated || !nextMarker
};
